
import ThemeSettings from '../commun/ThemeSettings';
import SideBar from '../commun/SideBar';
import Hearder from '../commun/Hearder';
import Footer from '../commun/Footer';

const EditAgentData = () => {

  return (
    <>
      <div className="wrapper">
        <SideBar />
        <div className="main-panel">
          <Hearder />
          <div className="container">
            <div className="page-inner">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title">Edit Agent Registration</div>
                    </div>
                    <form >
                      <div className="row">


                        <div className="col-md-4">
                          <div className="input-block mb-3">
                            <label className="col-form-label">Name of The Agency/Operator</label>
                            <input type="text" name="agencyName" className="form-control" placeholder="Name of The Agency/Operator" required />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input-block mb-3">
                            <label className="col-form-label">Address</label>
                            <textarea rows="2" name="address" className="form-control" placeholder="Address" ></textarea>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input-block mb-3">
                            <label className="col-form-label">State</label>
                            <input type="text" name="state" className="form-control" placeholder="State" />
                          </div>
                        </div>


                        <div className="col-md-4">
                          <div className="input-block mb-3">
                            <label className="col-form-label">Country</label>
                            <input type="text" name="country" className="form-control" placeholder="Country" />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input-block mb-3">
                            <label className="col-form-label">City</label>
                            <input type="text" name="city" className="form-control" placeholder="City" required />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input-block mb-3">
                            <label className="col-form-label">Pin Code</label>
                            <input type="number" name="pincode" className="form-control" placeholder="Pin Code" />
                          </div>
                        </div>


                        <div className="col-md-4">
                          <div className="input-block mb-3">
                            <label className="col-form-label">Agency/Operator Website</label>
                            <input type="text" name="website" className="form-control" placeholder="Website" required />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input-block mb-3">
                            <label className="col-form-label">Contact Person First Name</label>
                            <input type="text" name="firstName" className="form-control" placeholder="First Name" required />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input-block mb-3">
                            <label className="col-form-label">Middle Name</label>
                            <input type="text" name="middleName" className="form-control" placeholder="Middle Name" />
                          </div>
                        </div>


                        <div className="col-md-4">
                          <div className="input-block mb-3">
                            <label className="col-form-label">Last Name</label>
                            <input type="text" name="lastName" className="form-control" placeholder="Last Name" required />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input-block mb-3">
                            <label className="col-form-label">Mobile Number</label>
                            <input type="number" name="mobile" className="form-control" placeholder="Mobile Number" required />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input-block mb-3">
                            <label className="col-form-label">Telephone Number</label>
                            <input type="tel" name="tel" className="form-control" placeholder="Telephone Number" />
                          </div>
                        </div>


                        <div className="col-md-4">
                          <div className="input-block mb-3">
                            <label className="col-form-label">Telephone Extension</label>
                            <input type="tel" name="telext" className="form-control" placeholder="Extension" />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input-block mb-3">
                            <label className="col-form-label">Date of Birth</label>
                            <input type="date" name="dob" className="form-control" />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input-block mb-3">
                            <label className="col-form-label">Gender</label>
                            <select className="form-control" name="gender" >
                              <option>Select Gender</option>
                              <option>Male</option>
                              <option>Female</option>
                              <option>Other</option>
                            </select>
                          </div>
                        </div>


                        <div className="col-md-4">
                          <div className="input-block mb-3">
                            <label className="col-form-label">Email</label>
                            <input type="email" name="email" className="form-control" placeholder="Email" />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input-block mb-3">
                            <label className="col-form-label">Password</label>
                            <input type="password" name="password" className="form-control" placeholder="Password" />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input-block mb-3">
                            <label className="col-form-label">GST Number</label>
                            <input type="text" name="gst" className="form-control" placeholder="GST Number" />
                          </div>
                        </div>


                        <div className="col-md-4">
                          <div className="input-block mb-3">
                            <label className="col-form-label">PAN Number</label>
                            <input type="text" name="pan" className="form-control" placeholder="PAN Number" />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input-block mb-3">
                            <label className="col-form-label">Agency Logo</label>
                            <input type="file" className="form-control" />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input-block mb-3">
                            <label className="col-form-label">PMS Code</label>
                            <input type="text" name="pmscode" className="form-control" placeholder="PMS Code" />
                          </div>
                        </div>


                        <div className="col-md-4">
                          <div className="input-block mb-3">
                            <label className="col-form-label">Market Segment</label>
                            <select className="form-control" name="marketSegment">
                              <option>Select Market Segment</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input-block mb-3">
                            <label className="col-form-label">Business Source</label>
                            <select className="form-control" name="businessSource" >
                              <option>Select Business Source</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input-block mb-3">
                            <label className="col-form-label">Billing Instructions</label>
                            <select className="form-control" name="billingInstructions" >
                              <option>Select Billing Instructions</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="card-action text-end">
                        <button type="submit" className="btn btn-primary">Register Now</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
        <ThemeSettings />
      </div>
    </>
  )
}

export default EditAgentData;
